import {
    STORE_VIDEO_DEVICE_ID,
    GET_STORED_VIDEO_DEVICE_ID,
    SET_VIDEO_DEVICE_ID,
} from 'constants/ActionTypes';

export function getStoredVideoDeviceId() {
  // console.log('getVideoDeviceId ACTION');
  return {
    type: GET_STORED_VIDEO_DEVICE_ID
  };
}

export function setVideoDeviceId(videoDeviceId) {
  // console.log('setVideoDeviceId ACTION val: ', videoDeviceId);
  return {
    type: SET_VIDEO_DEVICE_ID,
    payload: videoDeviceId
  };
}

export function storeVideoDeviceId(videoDeviceId) {
  // console.log('changeVideoDeviceId ACTION val: ', videoDeviceId);
  return {
    type: STORE_VIDEO_DEVICE_ID,
    payload: videoDeviceId
  };
}
